export enum AnalyticsStatus {
  OK = 'ok',
  NO_TRANSACTIONS = 'no_transactions',
  NO_ANALYTICS_FOR_PERIOD = 'no_analytics_for_period',
  ERROR = 'error'
}

export enum AnalyticsField {
  DATE = 'date',

  REPO_ROOT = 'repo_root',
  ROOT_ID = 'root_id',

  ASSET_ID = 'asset_id',
  ASSET_TYPE = 'asset_type',
  ACCOUNT_ID = 'account_id',
  ACCOUNT_TYPE = 'account_type',

  CATEGORY = 'Category',
  SUBCATEGORY = 'Subcategory',

  AMOUNT = 'amount',

  POSITION_CLOSE = 'position_close',
  POSITION_COST = 'position_cost',
  POSITION_GAIN = 'position_gain',

  // Income
  CATEGORY_ACCOUNT_ID = 'category_account_id',
  CATEGORY_ACCOUNT_TYPE = 'category_account_type',

  // Position
  ASSET_CLOSE = 'asset_close',
  ASSET_GAIN = 'asset_gain',
  ASSET_COST = 'asset_cost',

  // Value Change
  D_POSITION_CLOSE = 'd_position_close',
  D_POSITION_COST = 'd_position_cost',
  D_POSITION_GAIN = 'd_position_gain',

  D_AMOUNT = 'd_amount',

  // Performance
  VALUE_START = 'value_start',
  CAPITAL_FLOW = 'capital_flow',
  CHANGE = 'change',
  PERCENT_CHANGE = 'percent_change',
  VALUE_END = 'value_end',
  IRR = 'irr',
  MOIC = 'moic',
  REALIZED_GAIN = 'realized_gain_income',
  UNREALIZED_GAIN = 'unrealized_gain_income',

  // Commitments
  ACCOUNT = 'account',
  ASSET = 'asset',
  INCEPTION_DATE = 'inception_date',
  ORIGINAL_COMMITMENT = 'original_commitment',
  REMAINING_COMMITMENT = 'remaining_commitment',
  INVESTED_CAPITAL = 'invested_capital',
  RECALLABLE_CAPITAL = 'recallable_capital',
  RETURNED_CAPITAL = 'returned_capital',
  INCOME = 'income',
  TOTAL_DISTRIBUTION = 'total_distribution',
  GAIN_LOSS = 'gain_loss',
  CURRENT_BALANCE = 'current_balance'
}
